export default function EmptySelect({ text }) {
    return (
        <span style={{ color: '#888', fontStyle: 'italic' }}>Select {text}</span>
    )
}
